import { Outlet, createFileRoute } from '@tanstack/react-router';
import { CapabilityGate } from '@/components/billing/CapabilityGate';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// Every inspection surface sits behind the Inspection capability, so the gate wraps the area layout
// rather than each page: an unentitled tenant meets the locked wall on entry and no inspection query
// ever fires (packaging AC3).
function InspectionAreaLayout() {
	return (
		<CapabilityGate capability="inspection">
			<Outlet />
		</CapabilityGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/inspection')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['inspections.read'], redirectTo: '/dashboard' }),
	component: InspectionAreaLayout,
});
